import React, { useEffect } from 'react';
import './Solutions.css';
import { SOLUTIONS, GROUP_META, ILABAPPS_BASE } from '../data/solutions';

function SolutionCard({ solution }) {
  const p = solution;
  return (
    <article className="solution-card">
      <div className="solution-card-head">
        <div className="solution-card-name">
          {p.prefix && <span className="solution-card-prefix">{p.prefix} </span>}{p.name}
        </div>
        <div className="solution-card-tagline">{p.tagline}</div>
      </div>
      <p className="solution-card-blurb">{p.blurb}</p>
      <ul className="solution-card-highlights">
        {p.highlights.map((h) => (
          <li key={h}>{h}</li>
        ))}
      </ul>
      <div className="solution-card-actions">
        <a
          href={`${ILABAPPS_BASE}/${p.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="solution-button solution-button-primary"
        >
          Find out more
        </a>
        <a href="/contact" className="solution-button solution-button-secondary">
          Contact Us
        </a>
      </div>
    </article>
  );
}

function SolutionGroup({ category, solutions }) {
  if (solutions.length === 0) return null;
  const meta = GROUP_META[category];
  return (
    <div className="solution-group">
      <div className="solution-group-eyebrow">{meta.eyebrow}</div>
      <h2 className="solution-group-title">{meta.title}</h2>
      <p className="solution-group-sub">{meta.sub}</p>
      <div className="solution-grid">
        {solutions.map((s) => (
          <SolutionCard key={s.id} solution={s} />
        ))}
      </div>
    </div>
  );
}

export default function Solutions() {
  useEffect(() => {
    document.title = 'Solutions';
    window.scrollTo(0, 0);
  }, []);

  const accelerators = SOLUTIONS.filter((s) => s.category === 'accelerator');
  const customerSolutions = SOLUTIONS.filter((s) => s.category === 'solution');

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/product_banner.webp)' }}>
        <h1 className="page-banner-title" id="solutions-banner-heading">
          Our Solutions
        </h1>
      </div>
      <main className="solutions-page-wrapper" aria-labelledby="solutions-banner-heading">
        <section className="solutions-hero" aria-labelledby="solutions-intro-heading">
          <div className="solutions-hero-content">
            <div className="solutions-hero-eyebrow">Mission-Ready Solutions by Inalab</div>
            <h2 id="solutions-intro-heading" className="solutions-hero-title">
              Purpose-built platforms for the <span className="solutions-hero-accent">mission at hand</span>
            </h2>
            <p className="solutions-hero-lead">
              Inalab delivers mission-ready iLAB Accelerators and Customer Solutions that help
              Federal agencies modernize legacy systems, secure cloud environments, turn scattered
              data into decisions, and streamline mission operations.
            </p>
            <p className="solutions-hero-body">
              Each solution addresses a specific operational challenge, from threat-informed ATO
              automation and AI-first DevSecOps to no-code data productization and predictive
              maintenance. Explore the portfolio below, or contact us for a tailored demo.
            </p>
            <div className="solutions-hero-stats">
              <div className="solutions-hero-stat">
                <div className="solutions-hero-stat-num">{SOLUTIONS.length}</div>
                <div className="solutions-hero-stat-label">iLAB Solutions</div>
              </div>
              <div className="solutions-hero-stat">
                <div className="solutions-hero-stat-num">IL5</div>
                <div className="solutions-hero-stat-label">GovCloud Ready</div>
              </div>
              <div className="solutions-hero-stat">
                <div className="solutions-hero-stat-num">API</div>
                <div className="solutions-hero-stat-label">First Architecture</div>
              </div>
              <div className="solutions-hero-stat">
                <div className="solutions-hero-stat-num">AWS</div>
                <div className="solutions-hero-stat-label">In Your Boundary</div>
              </div>
            </div>
          </div>
          <div className="solutions-hero-aside">
            <div className="solutions-hero-panel">
              <div className="solutions-hero-panel-label">{GROUP_META.accelerator.eyebrow}</div>
              <p className="solutions-hero-panel-text">{GROUP_META.accelerator.sub}</p>
              <div className="solutions-hero-pills">
                {accelerators.map((s) => (
                  <span className="solutions-hero-pill" key={s.id}>
                    {s.prefix ? `${s.prefix} ` : ''}{s.name}
                  </span>
                ))}
              </div>
            </div>
            <div className="solutions-hero-panel">
              <div className="solutions-hero-panel-label">{GROUP_META.solution.eyebrow}</div>
              <p className="solutions-hero-panel-text">{GROUP_META.solution.sub}</p>
              <div className="solutions-hero-pills">
                {customerSolutions.map((s) => (
                  <span className="solutions-hero-pill" key={s.id}>
                    {s.prefix ? `${s.prefix} ` : ''}{s.name}
                  </span>
                ))}
              </div>
            </div>
            <a href="/contact" className="solutions-hero-cta">Request a tailored demo</a>
          </div>
        </section>
        <SolutionGroup category="accelerator" solutions={accelerators} />
        <SolutionGroup category="solution" solutions={customerSolutions} />
      </main>
    </>
  );
}
